// Simple event emitter for category updates
// This allows multiple CategorySelect components to stay in sync

type CategoryEventListener = () => void;

class CategoryEventEmitter {
  private listeners: Set<CategoryEventListener> = new Set();

  subscribe(listener: CategoryEventListener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(): void {
    this.listeners.forEach(listener => listener());
  }
}

export const categoryEvents = new CategoryEventEmitter();
